import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { BASENAME } from './entrada';
import './movil.css';
import AdmisionPublica from './admision/AdmisionPublica';
import { instalarVisorApp } from './utils/visorApp';

// En la app instalada del teléfono, los PDF y documentos se abren en un visor
// dentro de la app en vez de una ventana o descarga del navegador.
instalarVisorApp();

// El formulario de admisión se abre sin sesión, desde un link de WhatsApp, y por
// eso se decide ACÁ y no dentro de App: así el paciente no pasa por el arranque
// de la aplicación —perfil, permisos, catálogo— ni queda a merced de una caída
// del servicio de sesiones, que es exactamente lo que pasó el 27 de agosto.
//
// La ruta va en query string (`/?a=TOKEN`) y no en el path: no depende de
// ninguna reescritura del hosting, así que un link repartido por WhatsApp no
// puede terminar en un 404.
const tokenAdmision = new URLSearchParams(window.location.search).get('a');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {tokenAdmision
      ? <AdmisionPublica token={tokenAdmision} />
      // Cada pantalla tiene su dirección (src/modulos.js → ruta). El prefijo
      // /portal lo decide src/entrada.js; las cuatro puertas usan las mismas rutas.
      : <BrowserRouter basename={BASENAME || '/'}><App /></BrowserRouter>}
  </React.StrictMode>
);
